import { RewardAdConfigSnapshot } from '../../../types/Ad.api.type';

interface Props {
  configs: Record<string, RewardAdConfigSnapshot>;
}

const LOCATION_LABELS: Record<string, string> = {
  ATTENDANCE_AD_BONUS: '출석 광고 보너스',
  ATTENDANCE_STREAK_SAVE: '출석 연속 유지',
  VOTE_AD_BONUS: '투표 광고 보너스',
  DAILY_AD_BONUS: '오늘의 투표 광고',
  MILESTONE_AD_BONUS: '이번주 투표 광고',
  CREATOR_MILESTONE_AD_BONUS: '작성자 광고 보너스',
  ANALYSIS_UNLOCK: '분석 해제 광고',
  COMMENT_AD_BONUS: '댓글 광고 보너스',
  SURVEY_LIKE_AD_BONUS: '설문 좋아요 광고',
  COMMENT_LIKE_AD_BONUS: '댓글 좋아요 광고',
  EXCHANGE: '환전 광고',
  WEEKLY_MISSION_AD_BONUS: '이번주 미션 광고',
};

/** G1-2 섹션 1: 터치포인트별 리워드/전면 비율 스냅샷 */
const RewardConfigSnapshot = ({ configs }: Props) => {
  const entries = Object.entries(configs);

  return (
    <div>
      <h4 className="text-sm font-semibold mb-2 text-gray-700">
        1. 터치포인트별 리워드/전면 비율 ({entries.length}개)
      </h4>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs border-collapse">
          <thead className="bg-gray-50">
            <tr>
              <th className="border px-2 py-1 text-left">터치포인트</th>
              <th className="border px-2 py-1 text-center">리워드%</th>
              <th className="border px-2 py-1 text-center">전면%</th>
              <th className="border px-2 py-1 text-center">리워드 활성화</th>
              <th className="border px-2 py-1 text-center">전면 활성화</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(([key, cfg]) => (
              <tr key={key} className="hover:bg-gray-50">
                <td className="border px-2 py-1">{LOCATION_LABELS[key] ?? cfg.watchLocationLabel ?? key}</td>
                <td className="border px-2 py-1 text-center font-medium">{cfg.rewardedAdRatio}%</td>
                <td className="border px-2 py-1 text-center font-medium">{100 - cfg.rewardedAdRatio}%</td>
                <td className="border px-2 py-1 text-center">{cfg.isRewardedAdEnabled ? '✅' : '—'}</td>
                <td className="border px-2 py-1 text-center">{cfg.isInterstitialAdEnabled ? '✅' : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RewardConfigSnapshot;
